var activeRequests = 0;
// loadingRegistry.js (A simple JS module outside of React)
export var LoadingRegistry = {
    start: function () { console.warn("Loading context not initialized."); },
    stop: function () { console.warn("Loading context not initialized."); },
};
// Functions to be called by Axios Interceptors
export var startLoading = function () {
    activeRequests++;
    // If this is the first request, set the global state to true
    if (activeRequests === 1) {
        LoadingRegistry.start();
    }
};
export var stopLoading = function () {
    // Only decrement if we have active requests
    if (activeRequests > 0) {
        activeRequests--;
    }
    // If the counter hits zero, set the global state to false
    if (activeRequests === 0) {
        LoadingRegistry.stop();
    }
};
